import { getAugmentedNamespace } from "./_commonjsHelpers.mjs";
import * as index from "../vendor/@formatjs/ecma402-abstract/lib/index.mjs";
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(index);
export {
  require$$0 as default
};
